import JSZip from "jszip";
import { saveAs } from "file-saver";

const PANE = '<pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/><selection pane="bottomLeft" activeCell="A2" sqref="A2"/>';

// Freezes the first row of every sheet in an .xlsx (SheetJS cannot write freeze panes itself).
const freezeSheetXml = (xml) => {
  if (/<pane /.test(xml)) return xml;
  if (/<sheetView[\s>]/.test(xml)) {
    return xml.replace(/<sheetView([^>]*?)\/>|<sheetView([^>]*?)>([\s\S]*?)<\/sheetView>/, (m, a, b) => {
      const attrs = (a ?? b ?? "").replace(/\/$/, "");
      return `<sheetView${attrs}>${PANE}</sheetView>`;
    });
  }
  const views = `<sheetViews><sheetView workbookViewId="0">${PANE}</sheetView></sheetViews>`;
  return xml.replace(/(<sheetFormatPr|<cols|<sheetData)/, `${views}$1`);
};

export const freezeHeaderXlsx = async (data) => {
  const zip = await JSZip.loadAsync(data);
  const names = Object.keys(zip.files).filter((n) => /^xl\/worksheets\/sheet\d+\.xml$/.test(n));
  for (const n of names) {
    zip.file(n, freezeSheetXml(await zip.file(n).async("string")));
  }
  return zip.generateAsync({
    type: "blob",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};

// Drop-in for XLSX.writeFile(wb, fileName): same file, header row frozen.
export const writeXlsxFrozen = async (XLSX, wb, fileName) => {
  const bytes = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  try {
    saveAs(await freezeHeaderXlsx(bytes), fileName);
  } catch (e) {
    console.error("Freeze header failed, saving plain file:", e);
    saveAs(new Blob([bytes], { type: "application/octet-stream" }), fileName);
  }
};
